var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useEffect, useRef } from 'react';
import { Animated, Pressable, View } from 'react-native';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { getSwitchProps, getSwitchStyles, getTrackStyle } from './SwitchStyles';
import { updateThumb } from './SwitchUtils';
import { Typography } from '../typography/Typography';
import { BLACK_700, BLACK_900 } from '../../constants';
export var Switch = forwardRef((props, ref) => {
  var _a, _b, _c;
  var fadeAnim = useRef(new Animated.Value(0)).current;
  var stateContext = useContext(StateConfigContext);
  var switchProps = getSwitchProps(props, stateContext);
  var stylesBasedOnState = useRef();
  var checked = switchProps.checked,
    style = switchProps.style,
    disabled = switchProps.disabled,
    controlState = switchProps.controlState,
    size = switchProps.size,
    _switchProps$testID = switchProps.testID,
    testID = _switchProps$testID === void 0 ? 'Switch' : _switchProps$testID,
    title = switchProps.title,
    subtext = switchProps.subtext,
    restProps = __rest(switchProps, ["checked", "style", "disabled", "controlState", "size", "testID", "title", "subtext"]);
  var transition = (_c = (_b = (_a = switchProps === null || switchProps === void 0 ? void 0 : switchProps.config) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b[size]) === null || _c === void 0 ? void 0 : _c.switchSize;
  var switchStyles = getSwitchStyles();
  useEffect(() => {
    updateThumb(fadeAnim, checked, transition);
  }, [checked, size]);
  var getPressableStyles = useCallback(event => {
    var styles = getTrackStyle(switchProps, event, fadeAnim);
    stylesBasedOnState.current = styles;
    return [styles.track, style];
  }, [switchProps]);
  return _jsxs(View, Object.assign({
    style: switchStyles.parentContainer
  }, {
    children: [(!!title || !!subtext) && _jsxs(View, Object.assign({
      style: switchStyles.contextBody
    }, {
      children: [!!title && _jsx(Typography, Object.assign({
        text: title,
        type: "body-para-sm-bold",
        color: BLACK_900
      }, getTestId(testID, 'title'))), !!subtext && _jsx(Typography, Object.assign({
        text: subtext,
        type: "body-para-xs",
        color: BLACK_700,
        style: switchStyles.subTitle
      }, getTestId(testID, 'subtext')))]
    })), _jsx(View, Object.assign({
      style: switchStyles.switchContainer
    }, {
      children: _jsx(Pressable, Object.assign({
        accessibilityRole: "switch",
        ref: ref,
        style: getPressableStyles,
        disabled: disabled || controlState == 'disabled'
      }, getTestId(testID), restProps, {
        children: () => _jsx(Animated.View, {
          style: [stylesBasedOnState.current.thumb]
        })
      }))
    }))]
  }));
});